'use es6';

import { createContext, useContext, Component } from 'react';
import { useSelector } from 'react-redux';
import get from 'transmute/get';
import createHocName from 'dashboard-components/decorator/createHocName';

// TBL-252 For now, this context should only be instantiated when the value is available
import { jsx as _jsx } from "react/jsx-runtime";
const UserInfoContext = /*#__PURE__*/createContext(null);
UserInfoContext.displayName = 'UserInfoContext';
export default UserInfoContext;
export const useUserInfoFromStore = () => {
  return useSelector(get('auth'));
};
export const useUserInfoFromContext = () => {
  return useContext(UserInfoContext);
};
export const useUserInfo = () => {
  const userInfoFromContext = useUserInfoFromContext();
  const userInfoFromStore = useUserInfoFromStore();
  return userInfoFromContext || userInfoFromStore;
};
export const withUserInfo = Subject => {
  var _class;
  return _class = class Decorated extends Component {
    constructor(...args) {
      super(...args);
      this.render = () => {
        return /*#__PURE__*/_jsx(UserInfoContext.Consumer, {
          children: userInfo => /*#__PURE__*/_jsx(Subject, Object.assign({}, this.props, {
            userInfo: userInfo
          }))
        });
      };
    }
  }, _class.displayName = createHocName('withUserInfo', Subject), _class;
};